module.exports = __webpack_public_path__ + "img/selected7-min.ebee36d1.png";